import React, { PureComponent } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";

class Layout_create_options extends PureComponent {
  render() {
    return (
      <div className="row" id="layout_create_options">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>Layout Create Options</h2>
              <p>
                Create options allows you to replace the default create record button with multiple create record buttons each with different default record data.
              </p>

              <h3>Compatibility</h3>
              <table style={{ width: "auto" }}>
                <tbody>
                  <tr>
                    <td className="b top">Page</td>
                    <td className="b top">Support</td>
                  </tr>
                  <tr>
                    <td className="b" style={{ paddingTop: 4 }}>
                      Dashboard
                    </td>
                    <td style={{ textAlign: "center" }}>
                      <i
                        className="material-icons"
                        style={{
                          position: "relative",
                          top: 3,
                          fontSize: 24,
                          color: "#D32F2F",
                          fontWeight: "bold"
                        }}
                      >
                        close
                      </i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b" style={{ paddingTop: 4 }}>
                      Record
                    </td>
                    <td style={{ textAlign: "center" }}>
                      <i
                        className="material-icons"
                        style={{
                          position: "relative",
                          top: 3,
                          fontSize: 24,
                          color: "#388E3C",
                          fontWeight: "bold"
                        }}
                      >
                        done
                      </i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b" style={{ paddingTop: 4 }}>
                      Report
                    </td>
                    <td style={{ textAlign: "center" }}>
                      <i
                        className="material-icons"
                        style={{
                          position: "relative",
                          top: 3,
                          fontSize: 24,
                          color: "#D32F2F",
                          fontWeight: "bold"
                        }}
                      >
                        close
                      </i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b" style={{ paddingTop: 4 }}>
                      Search
                    </td>
                    <td style={{ textAlign: "center" }}>
                      <i
                        className="material-icons"
                        style={{
                          position: "relative",
                          top: 3,
                          fontSize: 24,
                          color: "#D32F2F",
                          fontWeight: "bold"
                        }}
                      >
                        close
                      </i>
                    </td>
                  </tr>
                </tbody>
              </table>
              <h3>Properties</h3>
              <table>
                <tbody>
                  <tr>
                    <td className="b top">Property</td>
                    <td className="b top">Description</td>
                  </tr>
                  <tr>
                    <td className="b">name</td>
                    <td>Menu item display name.</td>
                  </tr>
                  <tr>
                    <td className="b">icon</td>
                    <td>Icon selected from the material icon font.</td>
                  </tr>
                  <tr>
                    <td className="b">color</td>
                    <td>Color of the icon.</td>
                  </tr>
                  <tr>
                    <td className="b">order</td>
                    <td>
                      Order that the datasets will appear in the group.
                      <br />
                      <i>1 - 10000 default is the order of the model</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">default</td>
                    <td>Object containing the default new record data.</td>
                  </tr>
                </tbody>
              </table>
              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="col-md-6 darkCol">
          <div className="contentDark">
            <section>
              <h2>Layout Example</h2>
            </section>
            <section>
              <h3>Example:</h3>
              <div className="darkCode">
                <div>&#123;</div>
                <div className="i1">
                  <span className="jsonG">"open_incident"</span>: &#123;
                </div>
                <div className="i2">
                  <span className="jsonG">"name"</span>:{" "}
                  <span className="jsonY">"New Open Incident"</span>,
                </div>
                <div className="i2">
                  <span className="jsonG">"icon"</span>:{" "}
                  <span className="jsonY">"description"</span>,
                </div>
                <div className="i2">
                  <span className="jsonG">"color"</span>:{" "}
                  <span className="jsonY">"#1976D2"</span>,
                </div>
                <div className="i2">
                  <span className="jsonG">"order"</span>:{" "}
                  <span className="jsonP">1</span>,
                </div>
                <div className="i2">
                  <span className="jsonG">"default"</span>: &#123;
                </div>
                <div className="i3">
                  <span className="jsonG">"text_status"</span>:{" "}
                  <span className="jsonY">"Open"</span>
                </div>
                <div className="i2">&#125;</div>
                <div className="i1">&#125;,</div>
                <div className="i1">
                  <span className="jsonG">"closed_incident"</span>: &#123;
                </div>
                <div className="i2">
                  <span className="jsonG">"name"</span>:{" "}
                  <span className="jsonY">"New Closed Incident"</span>,
                </div>
                <div className="i2">
                  <span className="jsonG">"icon"</span>:{" "}
                  <span className="jsonY">"description"</span>,
                </div>
                <div className="i2">
                  <span className="jsonG">"color"</span>:{" "}
                  <span className="jsonY">"#1976D2"</span>,
                </div>
                <div className="i2">
                  <span className="jsonG">"order"</span>:{" "}
                  <span className="jsonP">2</span>,
                </div>
                <div className="i2">
                  <span className="jsonG">"default"</span>: &#123;
                </div>
                <div className="i3">
                  <span className="jsonG">"text_status"</span>:{" "}
                  <span className="jsonY">"Done"</span>
                </div>
                <div className="i2">&#125;</div>
                <div className="i1">&#125;</div>
                <div>&#125;</div>
              </div>
            </section>
          </div>
        </div>
      </div>
    );
  }
}

export default Layout_create_options;



// WEBPACK FOOTER //
// ./src/components/knowlege/interface/Layout_create_options.js